export function limitDecimal(value: number) {
  return Math.round((value + Number.EPSILON) * 100) / 100;
}
